import { z } from 'zod'

// ─── Prato do dia (App cliente · F0, issue #209; spec §8.4 e §16.2) ───────────
//
// «Quando» (datas LOCAIS no fuso do restaurante, nunca unix-UTC):
//  - 'today'  → só hoje (data local; a API preenche a de hoje quando omitida);
//  - 'weekly' → toda [dias] (bitmask bit 0 = segunda, igual promoções);
//  - 'range'  → de [data] a [data], inclusive.
// Sem preço especial — preço diferente = promoção no mesmo item (decisão #2).
// Limite de 2 ativos por janela é validado no SERVIÇO (depende do fuso e do
// relógio; a porta só valida a forma).

/** Data local 'YYYY-MM-DD' (dia real do calendário). */
export const LOCAL_DATE_RE = /^\d{4}-\d{2}-\d{2}$/

const LocalDate = z.string().regex(LOCAL_DATE_RE, 'Use o formato YYYY-MM-DD')

export const DAILY_SPECIAL_MODES = ['today', 'weekly', 'range'] as const
export type DailySpecialModeValue = (typeof DAILY_SPECIAL_MODES)[number]

/** PUT /admin/products/:id/daily-special (#209) — active=false desliga. */
export const DailySpecialSetSchema = z
  .object({
    active: z.boolean(),
    mode: z.enum(DAILY_SPECIAL_MODES).optional(),
    /** 'today': data local; omitida = HOJE no fuso da casa (serviço preenche) */
    date: LocalDate.optional(),
    /** 'weekly': bitmask 1–127 (bit 0 = segunda) */
    days_of_week: z.number().int().min(1).max(127).optional(),
    /** 'range': datas locais, start <= end */
    start_date: LocalDate.optional(),
    end_date: LocalDate.optional(),
  })
  .superRefine((v, ctx) => {
    if (!v.active) return // desligar não precisa de janela
    if (v.mode === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['mode'],
        message: 'Escolha quando o prato do dia vale (só hoje, toda [dias] ou de-até).',
      })
      return
    }
    if (v.mode === 'weekly' && v.days_of_week === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['days_of_week'],
        message: 'Marque pelo menos um dia da semana.',
      })
    }
    if (v.mode === 'range') {
      if (v.start_date === undefined || v.end_date === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['start_date'],
          message: 'Informe a data inicial e a final.',
        })
      } else if (v.start_date > v.end_date) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['end_date'],
          message: 'A data final deve ser depois da inicial.',
        })
      }
    }
  })

export type DailySpecialSetInput = z.infer<typeof DailySpecialSetSchema>
